import React from 'react';
import { MoonLoader } from 'react-spinners';

interface LoadingProps {
  size?: number;
  color?: string;
  className?: string;
  text?: string;
}

const Loading: React.FC<LoadingProps> = ({
  size = 50,
  color = "#2550e8",
  className = "",
  text = "Loading..."
}) => {
  return (
    <div className={`flex flex-col items-center justify-center gap-4 ${className}`}>
      <MoonLoader
        color={color}
        size={size}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
      {text && (
        <div className="text-lg text-gray-600 dark:text-gray-400 animate-pulse">
          {text}
        </div>
      )}
    </div>
  );
};

export default Loading;